var $f2736b1dc5a311b1$exports = {};
$f2736b1dc5a311b1$exports = {
    "colorFormat": `Format de culoare`,
    "hex": `Hexazecimal`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$f2736b1dc5a311b1$exports as default};
//# sourceMappingURL=ro-RO.mjs.map
